/* External dependencies */
import { Observable, switchMap, map, from, catchError, of } from 'rxjs';
import { ofType } from 'redux-observable';

/* Local dependencies */
import { GetUserRequest, getUserSuccessAction } from './action';
import { getUser } from './service';
import { GetUserActionTypes } from './action';

const getUserEpic = (action$: Observable<GetUserRequest>) =>
  action$.pipe(
    ofType(GetUserActionTypes.GET_USER_REQUEST),
    switchMap((action) =>
      from(getUser(action.session?.userSub || action.id)).pipe(
        map((user) => getUserSuccessAction(user, action.session)),
        catchError((error) =>
          of({
            type: GetUserActionTypes.GET_USER_ERROR,
            error,
          }),
        ),
      ),
    ),
  );

export default getUserEpic;
